<template>
  <v-app id="portal">
    <v-content class="px-2">
      <titulo-responsivo :titulo="locale[local].screen.dependentes.string001" />
      <v-divider />

      <template>
        <v-container v-show="!showFormDependente" fluid class="pt-0">
          <v-row v-if="loading">
            <v-col cols="12" md="6" lg="4" v-for="index in 3" :key="index">
              <v-skeleton-loader
                transition="scale-transition"
                :types="{ skeleton: 'list-item, list-item-avatar-two-line@3' }"
                type="skeleton"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col
              v-for="(dependente, index) in listaDependentes"
              :key="index"
              cols="12"
              md="6"
              lg="4"
              class="px-2"
            >
              <cgi-card-dependente :dependente="dependente">
                
              </cgi-card-dependente>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <v-btn
        v-show="!showFormDependente"
        :loading="loadingButton"
        :disabled="loadingButton || loading"
        color="primary"
        x-large
        class="mr-4"
        @click="iniciarCadastroDependente"
      >
        {{ locale[local].screen.dependentes.string002 }}
      </v-btn>

      <div v-show="showFormDependente" class="pa-2">
        <form-dependente-responsivo
          ref="formDependente"
          @esconder-formulario="esconderFormulario"
          @mostrar-alerta="mostrarAlerta"
          @mostrar-mensagem="mostrarMensagem"
        >
        </form-dependente-responsivo>
      </div>

      <v-container grid-list-md fluid> </v-container>

      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >{{ locale[local].screen.dependentes.string003 }}</v-card-title
          >

          <v-container>
            <v-row justify="space-between pt-1">
              <v-col cols="3">
                <v-icon
                  v-if="dialogTipoMensagem == 'Sucesso'"
                  size="64"
                  color="green"
                  >mdi-check-circle</v-icon
                >
                <v-icon
                  v-else-if="dialogTipoMensagem == 'Alerta'"
                  size="64"
                  color="orange"
                  >mdi-alert</v-icon
                >
                <v-icon v-else size="64" color="red">mdi-close-octagon</v-icon>
              </v-col>

              <v-col cols="9">
                {{ dialogMensagem }}
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" text @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <cgi-alerta ref="alerta" />
    </v-content>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import Util from "@/components/api/Util";
import axios from "axios";

export default {
  data() {
    return {
      // Functions
      service: new Service(),
      util: new Util(),

      // Loaders
      loading: false,
      loadingButton: false,
      dialog: false,

      //Controllers de Texto
      dialogMensagem: null,
      dialogTipoMensagem: "",

      showFormDependente: false,

      listaDependentes: []
    };
  },
  mounted() {
    this.showFormDependente = false;
    this.carregarDependentes();
  },
  methods: {
    async iniciarCadastroDependente() {
      try {
        this.loadingButton = true;

        this.$refs.formDependente.limparFormulario();
        this.estagioForm = 1;

        axios
          .all([
            this.service.buscaUfs(),
            this.service.buscarDependencia(),
            this.service.buscarTiposNecessidades()
          ])
          .then(
            axios.spread(
              (respostaUF, respostaDependencia, respostaTiposNecessidades) => {
                if (respostaUF.status === 200) {
                  this.$refs.formDependente.listaUFs = respostaUF.data.ttUf;
                } else {
                  throw new Error();
                }

                if (respostaDependencia.status === 200) {
                  this.$refs.formDependente.listaDependencias =
                    respostaDependencia.data.ttDependenteGrau;
                } else {
                  throw new Error();
                }

                if (respostaTiposNecessidades.status === 200) {
                  this.$refs.formDependente.listaTiposNecessidades =
                    respostaTiposNecessidades.data.ttTipoNecessidade;
                } else {
                  throw new Error();
                }
              }
            )
          );

        this.loadingButton = false;
        this.showFormDependente = true;
      } catch (erro) {
        this.loadingButton = false;
        this.$refs.alerta.mostrarMensagem(erro, "red", true);
      }
    },
    esconderFormulario() {
      this.showFormDependente = false;
    },
    voltarEstagio(estagio) {
      this.estagioForm = estagio;
    },
    mostrarAlerta(mensagem) {
      this.$refs.alerta.mostrarMensagem(mensagem, "red", true);
    },
    mostrarMensagem(mensagem, tipoMensagem) {
      this.dialog = true;
      this.dialogMensagem = mensagem;
      this.dialogTipoMensagem = tipoMensagem;
    },
    async carregarDependentes() {
      try {
        this.loading = true;

        var resposta = await this.service.buscarDependentes({
          codPessoa: parseInt(localStorage.getItem("codPessoa"))
        });

        this.listaDependentes = resposta.data.ttDependentes;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    }
  }
};
</script>
